import React, { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {
  Box,
  BoxProps,
  IconButton,
  IconButtonProps,
  Stack,
  SwipeableDrawer,
  SwipeableDrawerProps,
} from '@mui/material';

import { Link } from 'react-router-dom';
import { getAppLogoUrl, SafeAreaGaps } from '../../../helper';
import NavBarContents from '../../../pages/UserPages/UserDashboard/components/NavBarContents';
import NavigationOptionsIconButton from '../../Headers/NavigationOptionsIconButton';

// STYLES
const drawerStyles: SwipeableDrawerProps['sx'] = {
  '& .MuiDrawer-paper': {
    boxSizing: 'border-box',
    width: '90vw',
    maxWidth: '600px',
  },
};

const containerStyles: BoxProps['style'] = {
  paddingTop: `calc(${SafeAreaGaps.top} + 50px)`,
  paddingBottom: `calc(${SafeAreaGaps.bottom} + 15px)`,
  paddingLeft: `calc(${SafeAreaGaps.top} + 15px)`,
  paddingRight: `calc(${SafeAreaGaps.right} + 15px)`,
  height: '100%',
};

const SubTopicDrawerButton: React.FC<IconButtonProps> = (props) => {
  // State
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  return (
    <div>
      <IconButton {...props} onClick={toggleDrawer}>
        <MenuIcon />
      </IconButton>
      <SwipeableDrawer
        open={isDrawerOpen}
        sx={drawerStyles}
        onOpen={toggleDrawer}
        onClose={toggleDrawer}
      >
        <div style={containerStyles}>
          <div>
            <Stack direction="row" alignItems="center" sx={{ pb: '15px' }}>
              <NavigationOptionsIconButton />
              <Box component={Link} to={`${process.env.PUBLIC_URL}/`}>
                <img
                  src={getAppLogoUrl('tp-logo-text-green-new.png')}
                  alt="tp-logo"
                  style={{ width: '120px' }}
                />
              </Box>
            </Stack>
          </div>
          <div>
            <NavBarContents />
          </div>
        </div>
      </SwipeableDrawer>
    </div>
  );
};

export default SubTopicDrawerButton;
